import { accountIdFormat } from "@redotech/redo-account-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const priceBookFilterNames = ["productSku"] as const;
export type PriceBookFilterName = (typeof priceBookFilterNames)[number];

export const getPriceBookUniqueValues = unaryRpc({
  name: "getPriceBookUniqueValues" as const,
  input: z.object({
    accountId: accountIdFormat.schema,
    filterName: z.enum(priceBookFilterNames),
    filterSearch: z.string().nullish(),
  }),
  output: z.object({ values: z.array(z.string()) }),
});
